export type CancelablePromise<T> = {
	cancel: () => void;
	promise: Promise<T>;
};

export default function makeCancelable<T>(promise: Promise<T>): CancelablePromise<T> {
	let wasCancelled = false;
	const wrappedPromise = new Promise((resolve, reject) => {
		promise.then((val: T) =>
			wasCancelled
				? reject({
						isCanceled: true
				  })
				: resolve(val)
		);
		promise.catch((error) =>
			wasCancelled
				? reject({
						isCanceled: true
				  })
				: reject(error)
		);
	});
	return {
		promise: wrappedPromise as Promise<T>,

		cancel() {
			wasCancelled = true;
		}
	};
}
